// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { mergeWithCss } from "@tps/XDL/Utilities/mergeWithCss";
import { modalButtonsActionStyles } from "@tps/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

myListsEditListFormStyles.nameTextField = {
    placeholder: translate("List Name"),
};

myListsEditListFormStyles.descriptionTextField = {
    placeholder: translate("Description"),
};

myListsEditListFormStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};
myListsEditListFormStyles.buttonsGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &::before {
                width: calc(100% - 32px);
            }
        `,
    }),
};
